'use client';

import { redirect } from 'next/navigation';
import type { ReactNode } from 'react';

export function TypForcedRedirection({
  children,
  pathname,
}: {
  children: ReactNode;
  pathname: string | null;
}) {
  const toRedirectPathname = window.sessionStorage.getItem('SAVED_TYP');
  let sanitizedPathname = toRedirectPathname?.split('?')[0];
  let finalPathname = pathname;

  if (finalPathname && finalPathname[finalPathname.length - 1] !== '/') {
    finalPathname += '/';
  }

  if (
    sanitizedPathname &&
    sanitizedPathname[sanitizedPathname.length - 1] !== '/'
  ) {
    sanitizedPathname += '/';
  }

  if (
    sanitizedPathname &&
    finalPathname &&
    toRedirectPathname &&
    sanitizedPathname !== finalPathname
  ) {
    redirect(toRedirectPathname);
  } else {
    return children;
  }
}
